import type { FC } from 'react';
import { InlineBlockEditController } from '@features/inline-block-edit';

export const StepBlockWysiwyg: FC = () => <InlineBlockEditController />;
